import { render } from "./incremental-data-index.vue?vue&type=template&id=437bfa5a&scoped=true"
import script from "./incremental-data-index.vue?vue&type=script&lang=js"
export * from "./incremental-data-index.vue?vue&type=script&lang=js"

import "./incremental-data-index.vue?vue&type=style&index=0&id=437bfa5a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437bfa5a"]])

export default __exports__